import React from 'react';
import styled from 'styled-components';
import { ScoreBreakdownResult } from 'Types/SRITypes';
import { NODATAFOUND } from 'Utils/Constants';
import {
  boxShadow, primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import ScoreStatsTip from './ScoreStatsTip';
// import { primaryFont, wMBold, wMedium } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: self-start;
  min-width: 400px;
  min-height: 200px;
  width: 400px;
  margin-bottom: 5px;
  background: #fff;
  padding: 12px 16px;
  box-shadow: ${boxShadow};
  border-radius: 8px;
  .left-side {
    display: flex;
    align-items: center;
  }
  .no-data-found {
    font-size: 16px;
    font-weight: ${wMBold};
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
    margin-bottom: 0px;
    text-align: center;
    width: 100%;
    margin-top: 70px;
  }
`;
type Props = {
  data: ScoreBreakdownResult[],
} | typeof defaultProps;

const defaultProps = {
  data: [],
};

const SriScoreCard = function SriScoreCard(props: Props) {
  const { data } = props;
  return (
    <Wrapper>
      {data.length > 0
        ? data.map((item) => (
          <ScoreStatsTip
            color={item.color}
            title={item.name}
            stats={item.count}
            pts={item.score}
          />
        )) : <h6 className="no-data-found">{NODATAFOUND}</h6>}

    </Wrapper>

  );
};

SriScoreCard.defaultProps = defaultProps;
export default SriScoreCard;
